import {observer} from "mobx-react";
import {Box, Button} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import {useStore} from "../../../stores/Store";
import React from "react";

interface Props {
    language: 'ru' | 'en' | 'ge' | 'fr'
}

export default observer(({language}: Props) => {
    const { CreditTextsStore, LanguageStore  } = useStore();
    const { create } = CreditTextsStore;

    return (
        <Box sx={{justifyContent: 'center', width: '100%', mt: 2, display: 'flex'}}>
            <Button
                startIcon={<AddIcon />}
                onClick={() => create(language)}
                variant={'contained'}
                color={'success'}
            >
                {LanguageStore.currentLanguageMessages.GeneralComponentLabels.createButtonLabel}
            </Button>
        </Box>
    )
})